<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"freightLine": "Freight Line",
		"description": "Description",
		"grossWeight": "Gross Weight",
		"height": "Height",
		"length": "Length",
		"marks": "Marks",
		"netWeight": "Net Weight",
		"numberOfPallets": "Number of Pallets",
		"numberOfUnits": "Number of Units",
		"packageTypeCode": "Package Type Code",
		"palletPackageCode": "Pallet Type",
		"palletPackageTypeCode": "Package Type",
		"palletPriceFactorPrice": "P.P. Price",
		"palletPriceFactorTruck": "P.P. Car",
		"volume": "Volume",
		"width": "Width"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"freightLine": "Fraktlinje",
		"description": "Beskrivelse",
		"grossWeight": "Brutto vekt",
		"chargableWeight": "Fraktberegningsvekt",
		"marks": "Merknad",
		"netWeight": "Netto vekt",
		"numberOfUnits": "Antall",
		"numberOfPackages": "Antall",
		"packageTypeCode": "Kode",
		"numberOfPallets": "Paller",
		"height": "Høyde",
		"width": "Bredde",
		"length": "Lengde",
		"volume": "Volum",
		"loadingMeters": "Lastemeter",
		"palletPackageCode": "Palletype",
		"palletPriceFactorPrice": "P.P. Pris",
		"palletPriceFactorTruck": "P.P. Bil"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t('freightLine')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('packageTypeCode')"
						:value="data.packageTypeCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('marks')"
						:value="data.marks"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('description')"
						:value="data.description"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('netWeight')"
						:value="data.netWeight"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('grossWeight')"
						:value="data.grossWeight"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('numberOfUnits')"
						:value="data.numberOfUnits"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('palletPackageCode')"
						:value="data.palletPackageCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('palletPriceFactorPrice')"
						:value="data.palletPriceFactorPrice"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('palletPriceFactorTruck')"
						:value="data.palletPriceFactorTruck"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('numberOfPallets')"
						:value="data.numberOfPallets"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('length')"
						:value="data.length"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('width')"
						:value="data.width"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('volume')"
						:value="data.volume"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('loadingMeters')"
						:value="data.loadingMeters"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'FreightLine',
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: repeat(3, minmax(150px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>